<script setup lang="tsx">
import { computed } from 'vue'
import HeaderComponent from '../shared/HeaderComponent.vue'
import IconButton from '../shared/IconButton.vue'
import { PermAllAssetWrite, PermAssetAdd, PermOwnAssetWrite } from '@/models/enums-generated'
import sliderStore from '@/stores/slider'
import AssetTable from './AssetTable.vue'
import ExportBtn from '../widgets/ExportBtn.vue'
import { hasPermission } from '@/services/utils'
import { assetRefreshCallback } from '../business_processes/shared'

const slider = sliderStore()
const canAdd = computed(() => hasPermission(PermAssetAdd))
const canImport = computed(() => canAdd.value || hasPermission(PermAllAssetWrite) || hasPermission(PermOwnAssetWrite))
</script>

<template>
	<HeaderComponent :title="$t('asset.label')">
		<template #right-side>
			<div class="d-flex align-items-center gap-2">
				<ExportBtn entity="asset" :can-import="canImport" @imported="assetRefreshCallback?.forEach((fn) => fn())"></ExportBtn>
				<IconButton v-if="canAdd" data-test="open-new-asset" :title="$t('misc.add')" class="bi bi-plus-square" @click="slider.openAsset">
				</IconButton>
			</div>
		</template>
	</HeaderComponent>
	<AssetTable></AssetTable>
</template>
